import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const PlayerJoin: React.FC = () => {
  const { lobbyId } = useParams();
  const [playerName, setPlayerName] = useState('');
  const [lobby, setLobby] = useState<any>(null);
  const [players, setPlayers] = useState<any[]>([]);

  useEffect(() => {
    fetchLobbyData();
  }, [lobbyId]);

  const fetchLobbyData = async () => {
    // Fetch lobby details
    const { data: lobbyData } = await supabase
      .from('lobbies')
      .select('*')
      .eq('id', lobbyId)
      .single();
    
    if (lobbyData) setLobby(lobbyData);

    // Fetch players
    const { data: playersData } = await supabase
      .from('players')
      .select('*')
      .eq('lobby_id', lobbyId)
      .order('joined_at', { ascending: true });

    if (playersData) setPlayers(playersData);
  };

  const handleJoin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!playerName.trim()) return;

    const { error } = await supabase
      .from('players')
      .insert([
        {
          lobby_id: lobbyId,
          name: playerName.trim(),
          status: 'waiting'
        }
      ]);

    if (error) {
      console.error('Error joining lobby:', error);
    } else {
      setPlayerName('');
      fetchLobbyData(); // Refresh players list
    }
  };

  if (!lobby) return <div>Loading...</div>;

  return (
    <div className="max-w-md mx-auto p-6 glass card">
      <h2 className="text-2xl font-bold mb-2 text-gray-900">Join {lobby.name}</h2>
      <p className="text-gray-600 mb-6">{lobby.description}</p>

      <form onSubmit={handleJoin} className="mb-6">
        <div className="flex flex-col sm:flex-row sm:space-x-2">
          <input
            type="text"
            placeholder="Enter your name"
            className="flex-1 rounded-xl border border-gray-200 bg-white/60 py-2 px-3 focus:outline-none focus:ring-2 focus:ring-accent"
            value={playerName}
            onChange={(e) => setPlayerName(e.target.value)}
            required
          />
          <button 
            type="submit"
            className="mt-2 sm:mt-0 w-full sm:w-auto bg-accent text-white px-4 py-2 rounded-full hover:bg-accent-600 shadow-soft-lg"
          >
            Join
          </button>
        </div>
      </form>

      <div>
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold mb-3">Players in Lobby ({players.length}/{lobby.max_players})</h3>
        </div>

        <ul className="space-y-3">
          {players.map((player) => (
            <li key={player.id} className="bg-white/70 p-3 rounded-xl shadow-sm">
              {player.name}
            </li>
          ))}
        </ul>
      </div>

      {/* Matchmaking modal is shown on the lobby creator page (queuing master), not the player join page */}
    </div>
  );
};

export default PlayerJoin;
